import React, { useState, useEffect } from "react";
import image1 from "../../images/aboutslush.png";
import image2 from "../../images/WW-Hero-1.jpg";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function AboutPage() {
	const [width, setWidth] = useState(window.innerWidth);
	const mobile = 414;
	useEffect(() => {
		const handleWindowResize = () => setWidth(window.innerWidth);
		window.addEventListener("resize", handleWindowResize);
		return () => window.removeEventListener("resize", handleWindowResize);
	}, []);
	return (
		<div className={styles.AboutPage}>
			<Helmet>
				<title>Wet Willie's Franchise | About us</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="logo" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>ABOUT US</h1>
			</div>
			<div className={styles.articleContainer}>
				<article className={styles.article}>
					{width > mobile ? (
						<section className={styles.section}>
							<figure>
								<img src={image1} alt="" />
							</figure>
						</section>
					) : null}
					<section className={styles.section2}>
						<h1>FLAVOR, FUN, AND SUCCESS</h1>
						<p>
							Wet Willie's began in 1988 by a small group of
							friends. The group began the research required to
							fuse the daiquiri concept with a casual, upbeat
							atmosphere, yielding the right mix of flavor, fun,
							and success. Our goal was to exceed our guests'
							expectation of a bar and a party, and to become an
							institution. We have surpassed our goal and are now
							a world-renowned institution serving the world's
							greatest frozen daiquiris. Since opening in 1990,
							Wet Willie's Daiquiri Bar/Restaurants have served
							guests and provided internet retail sales to
							customers from all 50 states and numerous foreign
							countries.
						</p>
						<br />
						<p>
							We are a highly innovative chain of Daiquiri
							Bar/Restaurants dedicated to serving great tasting
							frozen daiquiris with an honest portion of alcohol
							at fair prices in popular locations. We serve a
							variety of exotic as well as classic frozen
							daiquiris and we are always working on exciting new
							flavors to keep things interesting. We take pride in
							our menu featuring outstanding appetizers and unique
							entrees.
						</p>
						<br />
						<p>
							We provide a fun, safe environment for our guests by
							employing a talented, well-trained, and highly
							motivated staff. Our friendly employees are always
							happy to assist our guests. Great food, great
							drinks, great people and an awesome time: that's
							what we're about.
						</p>
					</section>
				</article>
			</div>
		</div>
	);
}
